export default "__VITE_ASSET__BQhrksgx__"